/** Поиск родительского элемента определенного класса
 *  
 * @param {obj} элемент
 * @param {className} класс
 */
function findParentByClassName(obj, className) {
	var res = obj;
	while (res = res.parentNode) {
		if (res == document)
			return false
		if (res.className.indexOf(className) != -1)
			return res;
	}
	return false;
}

/** Поиск родительского элемента определенного тэга
 *  
 * @param {obj} элемент
 * @param {nagName} тэг
 */
function findParentByTagName(obj, tagName) {
	if (!obj)
		return null;
	var res = obj;
	while (res = res.parentNode) {
		if (res == document)
			return false
		if (res.tagName.indexOf(tagName.toString().toUpperCase()) != -1)
			return res;
	}
	return false;
}

function showCustomDialog(title, text) {
	$("#customDialog .dialog-title").html(title);
	$("#customDialog .modal-pure__infopart").html(text);
	activateJSdialog('.customDialog');
}

function showDialog(options) {
	var defaults = {
		title: "Сообщение",
		content: "",
		url: null,
		callback: null,
		style: null,
	};
	if (typeof options !== "object") {
		options = {};
	}
	var settings = jQuery.extend({}, defaults, options);

	jQuery(".modalDialog__wrapper .modal-pure_title").html(settings.title);
	if (settings.url !== null && settings.url.length !== 0) {
		jQuery.ajax({
			url: settings.url,
			success: function (content) {
				jQuery(".modalDialog__wrapper .modal-pure__infopart").html(content);
				if (typeof settings.callback === "function") {
					settings.callback();
					jQuery('.modalDialog__wrapper .modal-pure__infopart [data-scrollbar]').scrollbar({
						"autoScrollSize": true,
					});
				}
				if (settings.style) {
					document.querySelector('.modalDialog__wrapper').classList.add(settings.style);
				}
				document.querySelector('.modalDialog__wrapper').classList.add('active');
				document.querySelector('body').classList.add('overflow');
				document.querySelector('body').classList.add('modal-opened');

			},
			error: function () {
				aAlert("Ошибка");
			}
		});
	} else {
		jQuery(".modalDialog__wrapper .modal-pure__infopart").html(settings.content);
		document.querySelector('.modalDialog__wrapper').classList.add('active');
		if (settings.style) {
			document.querySelector('.modalDialog__wrapper').classList.add(settings.style);
		}
		document.querySelector('body').classList.add('overflow');
		document.querySelector('body').classList.add('modal-opened');
	}

	document.querySelector('.modalDialog__wrapper').onclick = function (e) {
		if (e.target === this) {
			this.classList.remove('active');
			if (settings.style) {
				this.classList.remove(settings.style);
			}
			document.querySelector('body').classList.remove('overflow');
			document.querySelector('body').classList.remove('modal-opened');
		}
	};

	document.querySelector('.modalDialog_close').onclick = function () {
		document.querySelector('.modalDialog__wrapper').classList.remove('active');
		if (settings.style) {
			document.querySelector('.modalDialog__wrapper').classList.remove(settings.style);
		}
		document.querySelector('body').classList.remove('overflow');
		document.querySelector('body').classList.remove('modal-opened');
	};

	document.addEventListener('keydown', function (e) {
		let keyCode = e.keyCode;
		if (keyCode === 27) {
			document.querySelector('.modalDialog__wrapper').classList.remove('active');
			document.querySelector('body').classList.remove('overflow');
			document.querySelector('body').classList.remove('modal-opened');
		}
	});
}


function confirm_modify(date, id) {
	document.getElementById("compConfFormDate").innerHTML = date;
	document.getElementById("compConfFormId").value = id;
	activateJSdialog('.modConfirmDialog');
}

function reject_modify(date, id) {
	document.getElementById("compRejFormDate").innerHTML = date;
	document.getElementById("compRejFormId").value = id;
	activateJSdialog('.modRejectDialog');
}

function checkModRejectForm(form) {
	if (!form.reason.value) {
		aAlert("Укажите причину!");
		return false;
	}
	return true;
}

function showAuthDialog() {
//	event.preventDefault();
	activateJSdialog('.authDialog');
	document.querySelector('.login__auth').focus();
}

async function showPostAuthDialog(redirect_url, title, clickSelector) {
	if (isAuth && !Auth.get('isRegistered')) {
		await aAlert("<div>Вам необходимо завершить <a href='/reg'>регистрацию</a>.</div>");
		return;
	}

	if (typeof redirect_url === "undefined") {
		redirect_url = window.location.href.replace(window.location.origin, '');
	}
	if (typeof title === "undefined") {
		title = "Авторизация в системе";
	}
	if (typeof clickSelector !== "undefined") {
		setCookie("clickElementOnPostAuth", clickSelector);
	}

	activateJSdialog('.postAuthDialog');
	document.querySelector('.postAuthDialog .authb-tile').innerHTML = title;
	document.querySelector('.postAuthDialog input[name=uri]').value = redirect_url;
	var oauths = document.querySelectorAll(".postAuthDialog .oauths-container a");
	oauths.forEach(a => {
		try {
			const url = new URL(a.href);
			url.searchParams.set('state', redirect_url);
			a.href = url.toString();
		} catch (e) {
			console.warn('Invalid URL:', a.href);
		}
	});
}

function show_sign(id, bysignid) {
	if (!id) {
		$.get("log?subj=showing no id&msg=url=" + location.href);
		aAlert("Ошибка при отображении подписи!");
		return;
	}
	$.get("SignTools?op=showsign" + (bysignid ? 'id' : '') + "&id=" + id, null,
		function (data) {
			//			var	w = window.open("about:blank");
			//			alert(data);
			//			w.document.write(data);
			//			signSendForm(data, formId);
			$("#signDialog").html(data);
			$('#signDialog tr:contains("Количество заявок")').hide();
			$("#signDialog").dialog("open");

		});

}

function download_sign(id) {
	location.href = 'SignTools?op=downloadsign&id=' + id;
}

$(function () {
	$("#fileDialog").dialog({
		autoOpen: false,
		width: 600,
		modal: true
	});
	$("#signDialog").dialog({
		autoOpen: false,
		width: 600,
		height: 500,
		modal: true,
		open: function (e) {
			e.target.scrollTop = 0;
		},
		buttons: {
			"Закрыть": function () {
				$(this).dialog("close");
			}
		}
	});
	$("#wsBadConnectDialog").dialog({
		autoOpen: false,
		width: 300,
		height: 200,
		modal: true,
		open: function (e) {
//			e.target.scrollTop = 0;
		},
		buttons: {

		}
	});
//	inputTel(".podpiskaDialog input[name=phone]")l
});


function kadNumReportDialog(kadnum) {
//	event.preventDefault();
	//activateJSdialog('.kadNumDialog');

	if (!kadnum) {
		throw new Error("Возникла ошибка");
	}

	const className = ("kadNumDialog_" + kadnum).replace(/:/g, '-'); // Заменяем : на - , иначе не находит класс
	aDialog('.kadNumDialog__wrapper', className);

	const dialog = $(`.${className}`);
	const form = dialog.find("form");
	const btn = form.find('input[type="submit"]');

	dialog.find(".kadNumDialog__kadnum").text(kadnum);
	btn.attr("data-kad_number", kadnum);

	confirmContact({form: form, type: 'email'});
}

function showGosKeyFAQDialog() {
	var options = {
		title: "Использование ГосКлюча",
		content: "",
		url: "/ajax/getDialog?template=gosKeyFAQDialog",
		//style: "grey",
		callback: function () {

		}
	};
	showDialog(options);
}

function podpiskaLotDialog(lotId) {
	var options = {
		title: "Подписаться на обновления",
		content: "",
		url: "/ajax/lotSubscriptionDialog?id=" + lotId,
		style: "grey",
		callback: function () {
			inputTel("input[name=phone]");
		}
	};
	showDialog(options);
}

function autoReportDialog(lotId) {
	var options = {
		title: "Заказ отчета по осмотру объекта",
		content: "",
		url: "/ajax/autoReportDialog?act=getform&id=" + lotId + "&type=html",
		style: "grey",
		callback: function () {
			inputTel("input[name=phone]");
			setTimeout(() => $('#autoReportForm input[name="email"]').focus(), 1);
		}
	};
	showDialog(options);
}
function realtyReportDialog(lotId) {
	var options = {
		title: "Заказ отчета по осмотру объекта",
		content: "",
		url: "/ajax/realtyReportDialog?act=getform&id=" + lotId + "&type=html",
		style: "grey",
		callback: function () {
			inputTel("input[name=phone]");
		}
	};
	showDialog(options);
}

function vinReportDialog(lotId) {
	var options = {
		title: "Заказ Автоотчета",
		content: "",
		url: "/ajax/vinReportDialog?act=getform&id=" + lotId + "&type=html",
		style: "grey",
		callback: function () {
			inputTel("input[name=phone]");
			setTimeout(() => $('#vinReportForm input[name="email"]').focus(), 1);
		}
	};
	showDialog(options);
}


function podpiskaSearchDialog() {
	var options = {
		title: "Подписка на результаты поиска",
		content: "",
		url: "/ajax/searchSubscriptionDialog" + window.location.search,
		callback: function () {
			inputTel("input[name=phone]");
		}
	};
	showDialog(options);
	//var remark = $("#searchtext").val();
	//if (!remark) {
	//	remark = "Новая подписка на поиск";
	//}
	//$("#podpiskaSearchRemark").val(remark);
	//activateJSdialog('.podpiskaSearchDialog');

}

function qrDialog(id, isLotId = true, isZadat = true) {
	let options = null;
	
	const typeId = isLotId ? "lot_id" : "id";
	
	if(isZadat) {
		options = {
			title: '<span>Оплата по реквизитам</span>',
			content: "",
			url: `schet_zad?${typeId}=${id}&isQr=1`,
			style: "qrDialog",
			callback: function () {
			}
		};
	} else {
		options = {
			title: 'Реквизиты',
			content: "",
			url: `schet_usl?${typeId}=${id}&isQr=1`,
			style: "qrDialog",
			callback: function () {
			}
		};
	}
	
	window.ajaxParam = {
		typeId: typeId,
		id: id
	};
	
	if (!options) return;
	
	showDialog(options);
}

function chechCallbackForm(form) {
	var fio = jQuery("input[name='fio']", form).val();
	var phone = jQuery("input[name='phone']", form).val().replace(/\D/g, "");
	var msg = jQuery("input[name='msg']", form).val();
	var consent = (jQuery("input[name='consent']", form).length === 0 || jQuery("input[name='consent']", form).prop("checked"));
	var result = false;
	if (fio.length !== 0) {
		jQuery("input[name='fio']", form).css('opacity', '1');
	} else {
		jQuery("input[name='fio']", form).css('opacity', '');
	}
	if (phone.length > 0) {
		jQuery("input[name='phone']", form).css('opacity', '1');
	} else {
		jQuery("input[name='phone']", form).css('opacity', '');
	}
	if (msg.length > 0) {
		jQuery("input[name='msg']", form).css('opacity', '1');
	} else {
		jQuery("input[name='msg']", form).css('opacity', '');
	}
	if (fio.length === 0 || phone.length !== 11 || msg.length === 0 || !consent) {
		result = false;
	} else {
		result = true;
	}
//	jQuery("input.sf-submit", form).attr({"disabled": !result});
	jQuery("#callBack", form).attr({"disabled": !result});
	return result;
}
function sendCallbackForm(form) {
	if (!chechCallbackForm(form)) {
		return;
	}
	var fd = new FormData(form);
	fd.append("act", "get_tocken");
	jQuery.ajax({
		url: '/ajax/callback',
		type: 'post',
		data: fd,
		contentType: false,
		processData: false,
		dataType: 'json',
		success: function (response) {
			if (response.result) {
				jQuery.post("/ajax/callback?act=send", function (datasend) {
					if (datasend.result) {
						var options = {
							title: "Заявка отправлена",
							content: "Форма заказа обратного звонка успешно отправлена.<br>Оператор площадки свяжется с Вами в ближайшее время."
						};
						showDialog(options);
						form.reset();
						chechCallbackForm(form);
					} else {
						aAlert(datasend.data.message);
					}
				});
			} else {
				aAlert(response.data.message);
			}
		},
		error: function () {
			aAlert("Ошибка");
		}
	});

}

function showModalDialogWithAuth(url) {
	if (!isAuth) {
		showPostAuthDialog();
		return;
	}
	showModalDialog(url);
}

function showModalDialog(url) {
	jQuery.get(url, function (d) {
		if (typeof (d) === "object") {
			if (d.hasOwnProperty("error")) {
				aAlert("Ошибка:" + d.error);
				return;
			}
			if (d.hasOwnProperty("html")) {
				$("#modalDialog .modal-pure__infopart").html(d.html);
				activateJSdialog('.modalDialog');
				return;
			}
		}
		$("#modalDialog .modal-pure__infopart").html(d);
		activateJSdialog('.modalDialog');
	});
}

// Общая функция для обработки заказов
async function processOrder(config) {
	if (!config.url) {
		throw new Error("Необходимо передать url");
	}

	try {
		await ajaxJSON(config.url, (d) => {
			if (d.success) {
				if (d.url) {
					location.href = d.url;
				} else {
					// Выполняем действия при успехе
					if (config.onSuccess) {
						config.onSuccess(d);
					}
				}
				return;
			}

			if (d.err === "auth") {
				location.reload();
				return;
			}

			if (d.err) {
				aAlert("Ошибка: " + d.err);
				return;
			}

			if (d.confirm) {
				confirmOrder(config, d.confirm);
				return;
			}

			aAlert("Ошибка!!!");
		});
	} catch (e) {
		aAlert("Возникла ошибка");
	}
}

async function confirmOrder(config, message) {
	if (await aConfirm(message)) {
		config.url = addParamToUrl(config.url, 'confirm', '1');
		processOrder(config);
	}
	return;
}

async function orderSubscription(event) {
	event.preventDefault();
	const btn = event.target;

	const lotId = $(btn).attr("data-lot_id");
	const tarif = $(".lotSubscriptionDialog:visible input[name=tarifid]:checked").val();
	const URL = "podpiskaPay?new&lot_id=" + lotId + "&tarif=" + tarif;

	await processOrder({
		url: URL,
		onSuccess: (d) => {
			$(".modalDialog__wrapper:visible").removeClass('active').removeClass('grey');
			$("#podpisbtn_" + lotId).hide();
			if (d?.use_package === true) {
				aAlert("Подписка активирована");
				return;
			}
			$("#ofpay_" + lotId).show();
			aDialog('.podpiskaDialogDone__wrapper');
		}
	});
}

function addParamToUrl(url, paramName, paramValue) {
	// Разделяем базовый URL и параметры
	const [baseUrl, queryString] = url.split('?');
	const searchParams = new URLSearchParams(queryString);

	// Добавляем новый параметр
	searchParams.set(paramName, paramValue);

	// Собираем URL обратно
	return baseUrl + '?' + searchParams.toString();
}

async function orderKadnumReport(event) {
	event.preventDefault();
	const btn = event.target;

	const kad_number = btn.getAttribute('data-kad_number');
	if (!kad_number) {
		throw new Error("Не передан kad_number");
	}

	const URL = "kadVypiskaPay?new&kad_number=" + kad_number;

	await processOrder({
		url: URL,
		onSuccess: (d) => {
			$("[data-kadnumdiv='" + kad_number + "'] .btn").hide();
			$("[data-kadnumdiv='" + kad_number + "'] .paylink").show();
			$(".kadNumDialog__wrapper.active .kadNumDialog_close.modal-pure__close").click();
			aDialog('.kadNumDialogDone__wrapper');
		}
	});
}

async function orderPodpiskaSearch(event) {
	event.preventDefault();
	const btn = event.target;

	const remark = $("#podpiskaSearchRemark").val();
	if (!remark) {
		await aAlert("Укажите описание!");
		$("#podpiskaSearchRemark").focus();
		return;
	}

	var tarif = $(btn).attr("data-tarif");
	if (!tarif) {
		throw new Error("Не найден выбранный тариф");
	}

	const URL = "podpiskaPay" + location.search + "&newSearch&tarif=" + tarif + "&remark=" + encodeURIComponent(remark);

	await processOrder({
		url: URL,
		onSuccess: (d) => {
			$(".modalDialog__wrapper:visible").removeClass('active').removeClass('grey');
			$(".podpiskaSearchDialog__wrapper").removeClass('active');
			if (d?.use_package === true) {
				aAlert("Подписка активирована");
				return;
			}
			aDialog('.podpiskaDialogDone__wrapper');
		}
	});
}

function certDialog() {
	//удаляем обработчики на кнопках, если были.
	$('#button_cert-dalee').off('click');
	$('#button_cert-otmena').off('click');
	//вызываем окно диалога выбора сертификата.
	activateJSdialog('.dialog2');
	$("#button_cert-dalee").focus();
}

function photoAlbom(index_photo, arrLotName) {
	if (index_photo !== null && index_photo !== undefined && arrLotName !== [] && arrLotName !== undefined) {
		$('.photoAlbom__fotorama').empty();
		for (let i = 0; i < arrLotName.length; i++) {
			let clone = arrLotName[i].cloneNode(true);
			$('.photoAlbom__fotorama').append(clone);
		}
		activateJSdialog('.photoAlbom');
		$(function () {
			$('.fotorama').fotorama();
			let fotorama = $('.fotorama').fotorama().data('fotorama');
			fotorama.show(index_photo);
		});
	}
}

function activateJSdialog(selector) {
	//функция очищения структуры галереи
	function albomDestroy() {
		$(function () {
			$('.fotorama').fotorama().data('fotorama').destroy();
			$('.photoAlbom__fotorama').empty();
		});
	}
	//галерея 
	document.querySelector(selector + '__wrapper').classList.add('active');
	document.querySelector('body').classList.add('overflow');
	document.querySelector('body').classList.add('modal-opened');
	document.querySelector(selector + '__wrapper').onclick = function (e) {
		if (e.target === this) {
			this.classList.remove('active');
			document.querySelector('body').classList.remove('overflow');
			document.querySelector('body').classList.remove('modal-opened');
			//проверка для галереи(очистка  блока)
			if (selector === '.photoAlbom')
				albomDestroy();
			var clickElementOnPostAuth = getCookie("clickElementOnPostAuth");
			if (clickElementOnPostAuth.length > 0) {
				setCookie("clickElementOnPostAuth", '', 0);
			}
		}

	};


	document.querySelector(selector + '_close').onclick = function () {
		document.querySelector(selector + '__wrapper').classList.remove('active');
		document.querySelector('body').classList.remove('overflow');
		document.querySelector('body').classList.remove('modal-opened');
		//проверка для галереи(очистка  блока)
		if (selector === '.photoAlbom')
			albomDestroy();
		var clickElementOnPostAuth = getCookie("clickElementOnPostAuth");
		if (clickElementOnPostAuth.length > 0) {
			setCookie("clickElementOnPostAuth", '', 0);
		}
	};

	document.addEventListener('keydown', function (e) {
		let keyCode = e.keyCode;
		if (keyCode === 27) {
			document.querySelector(selector + '__wrapper').classList.remove('active');
			document.querySelector('body').classList.remove('overflow');
			document.querySelector('body').classList.remove('modal-opened');
			//проверка для галереи(очистка  блока)
			if (selector === '.photoAlbom')
				albomDestroy();
		}
	});

	var zoomBtn = document.querySelector(selector + '_zoom');
	if (zoomBtn !== null) {
		zoomBtn.onclick = function () {
			if (selector === '.photoAlbom') {
				var fotorama = $('.fotorama').fotorama().data('fotorama');
				ff = fotorama;
				console.log("fotorama", fotorama);
			}
		};
	}
}